import React, { useState, useContext, useRef } from 'react';
import * as Icon from 'react-feather';
import { Link } from 'react-router-dom';
import { DashboardContext } from 'context/DashboardContext';
import { ModalContext } from 'context/ModalContext';
import { Button, Input, Pagination } from 'antd';
import Loader from 'components/widgets/loader';
import NoData from 'components/no-data/NoData';
import AddDepartment from 'components/widgets/modals/AddDepartment';
import { KycContext } from "context/KycContext";

import Info from './steps/info/InfoContainer';
import Extra from './steps/extra/ExtraContainer';
import Additional from './steps/additional/AdditionalContainer';
import { ProductContext } from 'context/ProductContext';

export default function Products({ view_department, state, refetch }) {
    // access context
    const { paginate, numEachPage, handlePaginationChange } = useContext(DashboardContext);
    const { setModalShow, modalShow, modalClose } = useContext(ModalContext);

    const { agent, current } = useContext(ProductContext);
    console.log("CCURRENT product page==", current)

    const { Search } = Input;
    const [search, setSearch] = useState(null);
    // handle search

    const searchSpace = (event) => {
        let keyword = event.target.value;
        setSearch(keyword);
    };


    const productSteps = [
    {
      title: "Company Information",
      content: <Info />,
    },
    {
      title: "Additional Information",
      content:  <Additional />,
    },
    {
      title: "Extra and Other information",
      content:    <Extra />,
    },
  ];
  
  
    return (
        <>
            <div className="pageheader pd-t-25 pd-b-35">
                <div className="breadcrumb pd-0 mg-0">
                    <a className="breadcrumb-item" href="index.html">
                        <i className="icon ion-ios-home-outline" /> Home
                    </a>
                    <a className="breadcrumb-item active" href>
                        Dashboard
                    </a>
                </div>
            </div>
            <AddDepartment show={modalShow} onHide={modalClose} refetch={refetch} />
            <Button className="text-white btn-blue rounded float-right mb-3" onClick={() => setModalShow(true)}>
                Add Product
            </Button>

           {productSteps[current].content}

        </>
    );
}
